import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
const currentUserAuthorizationStructureState = buildServiceState({
    allowEmptyRequest: true,
    key: 'currentUserAuthorizationStructure',
    requireLoggedIn: true,
    service: Core.GetAuthorizationStructure,
});
export default currentUserAuthorizationStructureState;
//# sourceMappingURL=current-user-authorization-structure-state.js.map